// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { getVarType, makeDate, makeDateNow, getDangerousHTML } from "src/lib/utils.js";

// Stateful components

export class ExamTimetable extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            is_loading: true,
            all_exams: [],
            past_exams: [],
            exam_notes: null,
            exam_footer: null,
            active_accordions: []
        };

        // Binds
        this.toggleAccordion = this.toggleAccordion.bind(this);
    }

    componentDidMount() {
        var this_component = this;

        var all_exams = [];
        var past_exams = [];
        var exam_notes = null;
        var exam_footer = null;
        var now = makeDateNow().format();
        
        // get schedule data from storage
        var schedule_storage = squiz.fn.getStorage('getmyschedule', 'session', 'json');
        if (schedule_storage && schedule_storage['data']) {
            var exams_data = schedule_storage['data']['exams'];
            
            if (exams_data) {

                exam_notes = getDangerousHTML(exams_data[0]['ExamNotes']);
                exam_footer = getDangerousHTML(exams_data[2]['ExamFooter']);

                var exams = exams_data[1];

                if (exams) {

                    exams.forEach(exam => {

                        exam['eventType'] = 'exam';

                        // Format the date for display
                        if (exam.hasOwnProperty('Date')) {

                            // No timezone modifications required in this area
                            // "Saturday 25/1/2020" is always "2020-01-25T00:00:00" regardless of location
                            
                            // Make a sortdate property
                            var examDate = moment(exam['Date'], 'dddd D MMM YYYY HH:mma').format();

                            // Make the sort date - need to date + time
                            var sDate = exam['Date'];

                            if(isNaN(exam['Start_Time'][0])) {
                                sDate += ' ' + '0:01:am';
                            } else {
                                sDate += ' ' + exam['Start_Time'];
                            }

                            exam['SortDate'] = moment(sDate, 'dddd D MMM YYYY HH:mma').format();

                            // Format the date
                            exam['Date'] = moment(exam['Date'], 'dddd D MMM YYYY HH:mma').format('dddd DD MMMM YYYY');
                        }

                        // Check if items are object and make an array to preserve ordering
                        if( exam.hasOwnProperty('Accessible_Conditions') && typeof(exam['Accessible_Conditions']) === 'object' ) {
 
                            var newArr = [];
                            var accessible_conditions = exam['Accessible_Conditions'][0];
                            var conditions_type = getVarType(accessible_conditions);

                            if(conditions_type === 'object') {
                                Object.keys(accessible_conditions).map((value, key) => {
                                    var condition = accessible_conditions[key + 1];
                                    newArr.push(condition);
                                })
                            } else {
                                accessible_conditions.forEach(value => {
                                    newArr.push(value);
                                });
                            }                            

                            exam['Accessible_Conditions'] = newArr;
                        }

                        
                        // Check if the date has passed
                        if( makeDate(now).isAfter(examDate, 'day') ) {
                            past_exams.push(exam);
                        }

                        // If in the future....
                        if( makeDate(now).isSameOrBefore(examDate, 'day') ) {
                            all_exams.push(exam);
                        }

                    });

                    all_exams.sort((a, b) => {
                        var first_timestamp = new Date(a['SortDate']).getTime();
                        var second_timestamp = new Date(b['SortDate']).getTime();

                        if (first_timestamp > second_timestamp) {
                            return 1;
                        }

                        if (first_timestamp < second_timestamp) {
                            return -1;
                        }
                        
                        return 0;
                    });
                    
                }

            }

        }

        this_component.setState({
            is_loading: false,
            all_exams: all_exams,
            past_exams: past_exams,
            exam_notes: exam_notes,
            exam_footer: exam_footer
        });

    }


    //
    // Events
    //

    toggleAccordion(event) {
        event.preventDefault();

        var this_component = this;
        var id = event.currentTarget.getAttribute('id');

        var active_accordions = [...this_component['state']['active_accordions']];

        var index = active_accordions.indexOf(id);
        if (index !== -1) {
            active_accordions.splice(index, 1);
        } else {
            active_accordions.push(id);
        }

        this_component.setState({
            active_accordions: active_accordions
        });
       
    }



    //
    // Render
    //

    renderExam(exam_content) {

        // HTML attributes
        var exam_alt_def = getDangerousHTML(exam_content['ExamAltDef']);

        return (
            <>
                <span className="exams-modal__title">{exam_content['ExamTitle']} </span>
                <span className="exams-modal__sub-title">{exam_content['Status']}</span>
                
                <ul className="exams-modal__list">
                    
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Exam:</span>
                        <span>{exam_content['Exam']}</span>
                    </li>

                    {exam_content['Assessment_Type'] ? (
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Assessment Type:</span>
                            <span>{exam_content['Assessment_Type']}</span>
                        </li>
                    ) : null}

                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Date:</span>
                        <span>{exam_content['Date']}</span>
                    </li>

                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Start Time:</span>
                        <span>{exam_content['Start_Time']}</span>
                    </li>

                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Duration:</span>
                        <span>{exam_content['Duration']}</span>
                    </li>

                    {exam_content['Writing_Time'] ? (
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Writing Time:</span>
                            <span>{exam_content['Writing_Time']}</span>
                        </li>
                    ) : null}
                    
                    {exam_content['Reading_Time'] ? (
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Reading Time:</span>
                            <span>{exam_content['Reading_Time']}</span>
                        </li>
                    ) : null}

                    {exam_content['End_Time'] ? (
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">End Time:</span>
                            <span>{exam_content['End_Time']}</span>
                        </li>
                    ) : null}

                    {exam_content['Campus'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Campus:</span>
                        <span>{exam_content['Campus']}</span>
                    </li>
                    }

                    {exam_content['Venue'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Venue:</span>
                        <span>{exam_content['Venue']}</span>
                    </li>
                    }

                    {(!exam_content['Venue'] && !exam_content['Exam_Centre']) && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Venue:</span>
                        <span>To be finalised</span>
                    </li>
                    }

                    {exam_content['Building'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Building:</span>
                        <span>{exam_content['Building']}</span>
                    </li>
                    }

                    {exam_content['Room'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Room:</span>
                        <span>{exam_content['Room']}</span>
                    </li>
                    }

                    {exam_content['Your_Seat'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Your Seat:</span>
                        <span>{exam_content['Your_Seat']}</span>
                    </li>
                    }

                    {(exam_content['Note'] || exam_content['Notice']) && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Notes:</span>
                        <span>{exam_content['Note']} {exam_content['Notice']}</span>
                    </li>
                    }

                    {exam_content['Exam_Centre'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Exam Centre:</span>
                        <span>{exam_content['Exam_Centre']}</span>
                    </li>
                    }

                    {exam_content['Contact_Person'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Contact Person:</span>
                        <span>{exam_content['Contact_Person']}</span>
                    </li>
                    }

                    {exam_content['Phone'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Phone:</span>
                        <span>{exam_content['Phone']}</span>
                    </li>
                    }
                    
                    {exam_content['Email'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Email:</span>
                        <span>{exam_content['Email']}</span>
                    </li>
                    }

                    {exam_content['Address'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Address:</span>
                        <span>{exam_content['Address']}</span>
                    </li>
                    }

                    {exam_content['Instructions'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Instructions:</span>
                        <span>{exam_content['Instructions']}</span>
                    </li>
                    }

                    {(exam_content['Accessible_Conditions'] && !Array.isArray(exam_content['Accessible_Conditions']) ) && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Accessible Conditions:</span>
                        <span>{exam_content['Accessible_Conditions']}</span>
                    </li>
                    }

                    {(exam_content['Accessible_Conditions'] && Array.isArray(exam_content['Accessible_Conditions']) ) && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Accessible Conditions:</span>
                        <ul style={{ listStyleType: "none" }}>
                            {exam_content['Accessible_Conditions'].map((value, key) => {
                                if(value !== "\n") {
                                    value = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
                                    return <li key={key} dangerouslySetInnerHTML={{ __html: value }} />;
                                }
                            })}
                        </ul>
                    </li>
                    }

                    {(exam_content['Exam_Conditions'] && !Array.isArray(exam_content['Exam_Conditions']) ) && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Exam Conditions:</span>
                        <span>{exam_content['Exam_Conditions']}</span>
                    </li>
                    }

                    {(exam_content['Exam_Conditions'] && Array.isArray(exam_content['Exam_Conditions']) ) && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Exam Conditions:</span>
                        <ul style={{ listStyleType: "none" }}>
                            {
                                Object.keys(exam_content['Exam_Conditions'][0]).map((value, key) => {
                                    var condition = exam_content['Exam_Conditions'][0][key + 1];

                                    if(condition !== "\n") {
                                        condition = condition.replace(/(?:\r\n|\r|\n)/g, '<br>');
                                        return <li key={key} dangerouslySetInnerHTML={{ __html: condition }} />;
                                    }
                                })
                            }
                        </ul>
                    </li>
                    }

                    {(exam_content['Materials_Permitted'] && !Array.isArray(exam_content['Materials_Permitted']) ) && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Materials Permitted:</span>
                        <span>{exam_content['Materials_Permitted']}</span>
                    </li>
                    }

                    {(exam_content['Materials_Permitted'] && Array.isArray(exam_content['Materials_Permitted']) ) && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Materials Permitted:</span>
                        <ul style={{ listStyleType: "none" }}>
                            {
                                Object.keys(exam_content['Materials_Permitted'][0]).map((value, key) => {
                                    var material = exam_content['Materials_Permitted'][0][key + 1];


                                    if(material !== "\n") {
                                        material = material.replace(/(?:\r\n|\r|\n)/g, '<br>');
                                        return <li key={key} dangerouslySetInnerHTML={{ __html: material }} />;
                                    }
                                })
                            }
                        </ul>
                    </li>
                    }

                    {exam_content['Important_Notes'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Important Notes:</span>
                        <span>{exam_content['Important_Notes']}</span>
                    </li>
                    }

                    {exam_content['Instructions_To_Students'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Instruction to Students:</span>
                        <span>{exam_content['Instructions_To_Students']}</span>
                    </li>
                    }

                    {exam_content['Map'] && 
                    <li className="exams-modal__item">
                        <span className="schedule__exam-label">Map:</span>
                        <span>{exam_content['Map']}</span>
                    </li>
                    }

                    {exam_content['ExamAltDef'] && 
                    <li className="exams-modal__item" dangerouslySetInnerHTML={exam_alt_def}></li>
                    }

                </ul>
            </>
        );
    }

    renderAccordion(exam) {
        var this_component = this;
        
        var active_accordions = this_component['state']['active_accordions'];
        
        var btn_id = 'exam-accordion-btn-' + exam['StudentExamID'];
        var panel_id = 'exam-accordion-panel-' + exam['StudentExamID'];
        var panel_class = "accordion__content";

        var isExpanded = false;
        if (active_accordions.indexOf(btn_id) !== -1) {
            isExpanded = true;
        }
        
        if (!isExpanded) {
            panel_class += " collapsed";
        }

        return (
            <>
                <button id={btn_id} className="accordion__btn" data-toggle="collapse" data-target={"#" + panel_id} aria-expanded={isExpanded} aria-controls={panel_id} onClick={this_component.toggleAccordion}>
                    <span className="accordion__title">Previous Exam - {exam['Exam']}</span>
                    <span className="accordion__toggle"></span>
                </button>
                <div id={panel_id} className={panel_class} aria-labelledby={btn_id}>
                    <div className="exams-modal__details">
                        {this_component.renderExam(exam)}
                    </div>
                </div>
            </>
        );
    }

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];

        var is_loading = this_component['state']['is_loading'];
        var loading_image = configuration['images']['loader.gif']['url'];

        var all_exams = this_component['state']['all_exams'];
        var past_exams = this_component['state']['past_exams'];
        var exam_notes = this_component['state']['exam_notes'];
        var exam_footer = this_component['state']['exam_footer'];
        
        return (
            <div className="exams-modal__wrapper">

                {is_loading ? (
                    <div className="loading__wrapper">
                        <img src={loading_image} alt="Loading..." />
                    </div>
                
                ) : (
                    <>
                        <div className="exams-modal__notes" dangerouslySetInnerHTML={exam_notes}></div>

                        {all_exams.map((exam, exam_key) => {
                            return (
                                <div key={exam_key} className="exams-modal__details">
                                    {this_component.renderExam(exam)}
                                </div>
                            );
                        })}

                        <div className="exams-modal__accordions">
                            {past_exams.map((exam, exam_key) => {
                                return (
                                    <div key={exam_key} className="accordion">
                                        {this.renderAccordion(exam)}
                                    </div>
                                );
                            })}
                        </div>

                        <div className="exams-modal__footer" dangerouslySetInnerHTML={exam_footer}></div>
                    
                    </>
                )}
                

            </div>
        );
    }

};

ExamTimetable.contextType = PortalContext;